import PropTypes from "prop-types";
import ProductImage from "../ProductImage";
import { useState, useEffect } from "react";
import styles from "./index.css";
import classnames from "classnames";

const HoverableProductImage = ({
  additionalImageUrls,
  description,
  focused,
  ...rest
}) => {
  const [hovered, setHovered] = useState(false);
  const [hoverImageLoaded, setHoverImageLoaded] = useState(false);
  const [hoverImage, setHoverImage] = useState(additionalImageUrls[0]);
  const [clientLoaded, setClientLoaded] = useState(false);

  const onMouseOver = () => setHovered(true);
  const onMouseLeave = () => setHovered(false);

  useEffect(() => {
    setClientLoaded(true);
  }, []);

  return (
    <>
      <ProductImage
        {...{
          alt: `${description} - view 1`,
          onMouseOver,
          ...rest
        }}
      />
      {hoverImage && clientLoaded ? (
        <ProductImage
          {...{
            alt: `${description} - view 2`,
            className: classnames(styles.secondImage, {
              [styles.focused]: focused,
              [styles.show]: hovered,
              [styles.fade]: hoverImageLoaded
            }),
            onMouseLeave,
            image: hoverImage,
            onError: () => setHoverImage(null),
            onLoad: () => setHoverImageLoaded(true)
          }}
        />
      ) : null}
    </>
  );
};

HoverableProductImage.propTypes = {
  additionalImageUrls: PropTypes.arrayOf(PropTypes.string).isRequired,
  description: PropTypes.string.isRequired,
  focused: PropTypes.bool,
  focus: PropTypes.bool
};

export default HoverableProductImage;
